<template lang="pug">
span(v-if="loading")
  .blur-progress-loader-div
  .progress_circle_loader-div
    v-progress-circular(indeterminate color="primary" :size="100" :width="7")
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  components: {},
  props: {
    loading: { type: Boolean, default: false }
  },
  setup(props) {
    return {}
  }
})
</script>

<style lang="sass" scoped>
.blur-progress-loader-div
  position: fixed
  top: 0
  left: 0
  height: 100vh
  width: 100vw
  opacity: 0.3
  background-color: lightblue
  z-index: 998
.progress_circle_loader-div
  position: fixed
  top: calc(50vh - 50px)
  left: calc(50vw - 50px)
  z-index: 999
</style>
